<template>
  <div class="row">
    <div class="col">

      <!-- widgets -->
      <div class="row">

        <!-- done -->
        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-success">
              <i class="fas fa-check"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Concluído</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.done == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.done }}</div>
              </div>
            </div>
          </div>
        </div>
       
        <!-- pending -->
        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-warning">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Pendente</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.pending == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.pending }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- error -->
        <div class="col-4">
          <div class="card card-statistic-1">
            <div class="card-icon bg-danger">
              <i class="fas fa-times"></i>
            </div>
            <div class="card-wrap">
              <div class="card-header">
                  <h4>Erro</h4>
              </div>
              <div class="card-body">
                <div
                  v-if="widgetItems.error == 0 && widgetItems.loading"
                  class="spinner-border spinner-border spinner-border-sm"
                  role="status"
                ></div>
                <div v-else>{{ widgetItems.error }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- grid -->
      <div class="row">
        <div class="col">
          <div class="card p-4">

            <!-- table -->
            <vue-good-table v-if="logs.length > 0"
              :columns="tableColumns"
              :rows="logs"
              :pagination-options="tablePagination"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar..'
              }"
              styleClass="vgt-table"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == '_status'" class="text-center">
                  <span v-if="props.row.status === 2" class="rounded-status-warning"></span>
                  <span v-if="props.row.status === 1" class="rounded-status-success"></span>
                  <span v-if="props.row.status === 0" class="rounded-status-error"></span>
                </span>
                <span v-if="props.column.field == '_validation'" class="text-center">
                  <div v-if="props.row.users.kanban == null" class="text-danger"><i class="fas fa-exclamation-triangle" title="Kanban não configurado"></i></div>
                </span>
                <span v-if="props.column.field == '_actions'" class="actions">
                  <button class="btn btn-sm btn-outline-success" v-if="props.row.status !== 1" title="Liberar Fila" @click="updateStatus(props.row, 'log')">
                    <i class="fas fa-check"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-secondary" title="Visualizar Itens" @click="viewLogItems(props.row)">
                    <i class="far fa-eye"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template slot="pagination-bottom">
                <table-pagination-component :_options="tablePaginationOptions" @paginate="pagination"></table-pagination-component>
              </template>
            </vue-good-table>
            <div v-else class="text-center p-3 text-muted">
                <h5>Nenhum log encontrado!</h5>
            </div>
            <!-- end table -->

            <div class="text-center p-4 text-muted" v-if="loading && logs.length == 0">
              <h5>Carregando...</h5>
              <p>Aguarde até que os dados sejam carregados...</p>
            </div>

          </div>
        </div>
      </div>

      <!-- modal -->
			<div class="modal fade" id="modalLogItems" tabindex="-1" aria-labelledby="modalLogItemsLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalLogItemsLabel">Itens do Log</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<vue-good-table v-if="logs.length > 0"
              :columns="tableColumnsItems"
              :rows="logItems"
              :pagination-options="tablePagination"
              :search-options="{
                enabled: true,
                placeholder: 'Buscar..'
              }"
              styleClass="vgt-table"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == '_status'" class="text-center">
                  <span v-if="props.row.status === 2" class="rounded-status-warning"></span>
                  <span v-if="props.row.status === 1" class="rounded-status-success"></span>
                  <span v-if="props.row.status === 0" class="rounded-status-error"></span>
                </span>
                <span v-if="props.column.field == '_actions'" class="actions">
                  <button class="btn btn-sm btn-outline-success" v-if="props.row.status !== 1" title="Liberar Fila" @click="updateStatus(props.row, 'item')">
                    <i class="fas fa-check"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template slot="pagination-bottom">
                <table-pagination-component :_options="tablePaginationOptionsItems" @paginate="paginationItems"></table-pagination-component>
              </template>
              </vue-good-table>
              <div v-else class="text-center p-3 text-muted">
                  <h5>Nenhum item encontrado!</h5>
              </div>
						</div>
					</div>
				</div>
			</div>

    </div><!-- col -->
  </div><!-- row -->
</template>

<script>
  import configData from "../../config.js";
  export default {
    mixins: [configData],
    data() {
      return {
        logs: [],
        logItems: [],
        loading: false,
        generatedActivities: [],
        selectedLog: {
          id: null
        },
        searchTerm: '',
        widgetItems: {
          done: 0,
          pending: 0,
          error: 0,
          loading: false
        },
        tablePagination: configData.tablePagination,
        tableColumns: [
          {
            label: "Status",
            field: "_status",
            sortable: false,
            width: "80px",
          },{
            label: "Usuário",
            field: "user.profile.name"
          },{
            label: 'Data e Hora',
            field: 'created_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Ações",
            field: "_actions",
            width: "80px",
            sortable: false
          }
        ],
        tableColumnsItems: [
        {
            label: "Status",
            field: "_status",
            sortable: false,
            width: "80px",
          },{
            label: 'Data e Hora',
            field: 'created_at',
            type: 'date',
            dateInputFormat: "yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSXXX",
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
          },{
            label: "Ações",
            field: "_actions",
            width: "140px"
          }
        ],
        tablePaginationOptions: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
        tablePaginationOptionsItems: {
					currentPage: 1,
					currentPerPage: 10,
					from: 0,
					to: 0,
					total: null
				},
      }
    },
    mounted() {
      this.loadLogs();
    },
    methods: {
      pagination(page){
				this.tablePaginationOptions = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.loadLogs();
			},
      paginationItems(page){
				this.tablePaginationOptionsItems = {
					currentPage: page.options.currentPage,
					currentPerPage: page.options.currentPerPage,
					from: page.options.from,
					to: page.options.to,
					total: page.options.total
				};
				this.loadLogItems();
			},
      loadLogs() {
        let _this = this;
        _this.loading = true;
				_this.logs = []
				var params = {
					page: _this.tablePaginationOptions.currentPage,
					perPage: _this.tablePaginationOptions.currentPerPage,
				};
				axios.post("/admin/log/synchronization/filter", _this.filterItems, {params: params}).then((res) => {
					const { data, total, from, to } = res.data.data;
					_this.tablePaginationOptions.total = total;
					_this.tablePaginationOptions.from = from;
					_this.tablePaginationOptions.to = to;
					_this.logs = [...data];
          _this.loading = false;
					this.validateWidgets();
				}).catch((err) => {
          _this.loading = false;
				});
      },
      loadLogItems(modal = false){
        if(this.selectedLog.id != null){
          let _this = this;
          _this.loading = true;
          _this.logsItems = []
          var params = {
            page: _this.tablePaginationOptionsItems.currentPage,
            perPage: _this.tablePaginationOptionsItems.currentPerPage,
          };
          axios.post("/admin/log/synchronization/items", {log: _this.selectedLog.id}, {params: params}).then((res) => {
            const { data, total, from, to } = res.data.data;
            _this.tablePaginationOptionsItems.total = total;
            _this.tablePaginationOptionsItems.from = from;
            _this.tablePaginationOptionsItems.to = to;
            _this.logItems = [...data];
            _this.loading = false;

            if(modal){
              $("#modalLogItems").modal('show');
            }

          }).catch((err) => {
            _this.loading = false;
          });
        }
      },
      updateStatus(log, type){

        this.$swal({
          title: "Atualizar Status",
          text: "Tem certeza que deseja atualizar esse Status?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Atualizar",
          cancelButtonText: "Cancelar"
        })
        .then(alertConfirm => {
          if (alertConfirm.isConfirmed) {

            this.loading = true;
            var dataParams = {
              type: type,
              log_id: log.id
            };
            axios.post("/admin/log/synchronization", dataParams).then((res) => {
              this.loading = false;

              if(type == 'log'){
                this.loadLogs();
              } else {
                this.loadLogItems();
              }

            }).catch((err) => {
              this.loading = false;
            });

          }
        });

      },
      validateWidgets(){
        let _this = this;
        _this.widgetItems.loading = true;
        _this.widgetItems.done = 0;
        _this.widgetItems.pending = 0;
        _this.widgetItems.error = 0;

        axios.post("/admin/log/synchronization/widgets").then((res) => {
          const { done, pending, error } = res.data;
          _this.widgetItems.done = done;
          _this.widgetItems.pending = pending;
          _this.widgetItems.error = error;
          _this.widgetItems.loading = false;
        }).catch((err) => {
          _this.widgetItems.loading = false;
        });
      },
      viewLogItems(log){
        this.selectedLog = log;
        this.loadLogItems(true);

      }
    }
  }
</script>
